<section
  class="partners-section mx-auto w-full rounded-2xl border px-5 py-10 md:px-10 lg:px-16"
>
  <div class="mx-auto flex w-full flex-col items-center gap-8">
    <span
      class="partners-badge inline-flex items-center justify-center"
    >
      <img
        [src]="partnerIconPath"
        alt=""
        aria-hidden="true"
        class="h-4 w-4 object-contain"
      />
      Partners and products
    </span>

    <h2 class="partners-title text-center font-bold leading-tight">
      Trusted ecosystem partners across healthcare and innovation
    </h2>

    <div class="partners-grid grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
      @for (partner of partners; track partner.name) {
        @if (partner.url) {
          <a
            [href]="partner.url"
            target="_blank"
            rel="noopener noreferrer"
            [attr.aria-label]="partner.name"
            class="partner-card flex min-h-[110px] items-center justify-center rounded-2xl border p-4 md:min-h-[124px] md:p-5"
          >
            <img
              [src]="partner.logoPath"
              [alt]="partner.logoAlt"
              class="partner-logo w-full object-contain"
              loading="lazy"
            />
          </a>
        } @else {
          <article
            class="partner-card flex min-h-[110px] items-center justify-center rounded-2xl border p-4 md:min-h-[124px] md:p-5"
          >
            <img
              [src]="partner.logoPath"
              [alt]="partner.logoAlt"
              class="partner-logo w-full object-contain"
              loading="lazy"
            />
          </article>
        }
      }
    </div>
  </div>
</section>
